import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { AlertBox } from './EquipmentOptionStyled';

const AlertIcons = ({ alerts }) => (
    <Stack direction="row" spacing={0.5} alignItems="center">
        {alerts.map((alert) => (
            <AlertBox key={alert.name} bgcolor={alert.color}>
                {alert.name[0]}
            </AlertBox>
        ))}
    </Stack>
);

AlertIcons.propTypes = {
    alerts: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            color: PropTypes.string,
        })
    ),
};

export default AlertIcons;
